import React from "react";

import FormSection from "../../common/FormSection";
import FormStep from "../../common/FormStep";
import YesNoField from "../../common/YesNoField";

const BondingFields = () => {
  return (
    <FormStep>
      <FormSection
        title="J. Bonding Program Information"
        subtitle={<em>Applicable to Construction Subcontractors Only</em>}
      >
        <YesNoField
          label="1. Do you have a surety bonding program?"
          name="suretyBondingProgram"
          required={true}
        />
        <YesNoField
          label="2. Are you able to provide bid bonds?"
          name="bidBonds"
          required={true}
        />
      </FormSection>
    </FormStep>
  );
};

export default BondingFields;
